export enum CookieConsentModel {
  Required = 'required',
  All = 'all'
}
